export function formSwitcher() {
    const cards  = document.querySelectorAll('.forms-card');
    const forms  = document.querySelectorAll('.forms__form');
    const select = document.querySelector('.forms__select');

    function showForm(target) {
        // Verberg alle forms
        forms.forEach(f => f.style.display = 'none');

        // Toon doel-formulier
        const form = document.getElementById(target);
        if (form) {
            form.style.display = 'block';
        }

        // Active class op kaarten (desktop)
        cards.forEach(c => c.classList.remove('active'));
        const match = document.querySelector(`.forms-card[data-target="${target}"]`);
        if (match) match.classList.add('active');
    }

    // Card clicks (desktop/tablet)
    cards.forEach(card => {
        card.addEventListener('click', () => {
            const target = card.dataset.target;

            // Sync select (mobiel)
            if (select) select.value = target;

            showForm(target);
        });
    });

    // Select change (mobiel)
    if (select) {
        select.addEventListener('change', () => {
            const target = select.value;
            showForm(target);
        });
    }

    // Init: open eerste formulier
    if (cards.length > 0) {
        const firstTarget = cards[0].dataset.target;
        showForm(firstTarget);

        if (select) select.value = firstTarget;
    }
}